export const amountEquals = (amount1: number, amount2: number): boolean =>
    typeof amount1 === 'number' &&
    !isNaN(amount1) &&
    typeof amount2 === 'number' &&
    !isNaN(amount2) &&
    Math.abs(amount1 - amount2) < 0.001
